import { useIsAuthenticated, useMsal } from '@azure/msal-react'
import { loginRequest } from '@config/auth.config'
import { useCallback, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

const Login = () => {
  const { instance, inProgress } = useMsal()
  const isAuthenticated = useIsAuthenticated()
  const navigate = useNavigate()

  const handleLogin = useCallback(async () => {
    if (isAuthenticated) {
      navigate('/')
      return
    }
    if (inProgress === 'none') {
      try {
        await instance.initialize()
        await instance.loginRedirect(loginRequest)
        navigate('/')
      } catch (e) {
        console.error(e)
      }
    }
  }, [instance, isAuthenticated, inProgress, navigate])

  useEffect(() => {
    handleLogin()
  }, [handleLogin])

  return <></>
}

export default Login
